import { render, staticRenderFns } from "./breastReport.vue?vue&type=template&id=4f3d659c&scoped=true"
import script from "./breastReport.vue?vue&type=script&lang=js"
export * from "./breastReport.vue?vue&type=script&lang=js"
import style0 from "./breastReport.vue?vue&type=style&index=0&id=4f3d659c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3d659c",
  null
  
)

export default component.exports